<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemDeprecateMode} from "@/modules/redactor/models/item/deprecate/ItemDeprecateMode";

export default {
  name: "r-item-deprecate-mode",
  props: {
    model: VueTypes.instanceOf(ItemDeprecateMode),
    label: VueTypes.string.def("Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemDeprecateMode.getValues();
    }
  }
}
</script>